<template>
  <div class="@container/categories">
    <div class="grid grid-cols-1 gap-x-20 gap-y-6 @3xl/categories:grid-cols-2">
      <div
        v-for="category in categoriesList"
        :key="category.key"
        class="grid grid-cols-2 gap-2 items-start justify-between font-semibold"
      >
        <span class="flex gap-3 items-center">
          <TIcon
            v-if="canShowIcon"
            :icon="['far', lookupBookingReviewCategoryIcon(category.key)]"
            class="text-primary-500 @max-xs/categories:hidden"
            size="xl"
          />

          {{ category.label }}
        </span>

        <div class="flex items-center w-full justify-end gap-2">
          <TProgress
            v-if="canShowProgressBar"
            :value="category.value"
            :max="5"
            size="sm"
          />
          <span>{{ formatWithPrecision(category.value) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BOOKING_REVIEW_CATEGORIES_ORDERED } from '~/constants'
import type { ReviewCategories } from '~/components/review/types'

const props = defineProps<{
  categories: ReviewCategories
  canShowIcon?: boolean
  canShowProgressBar?: boolean
}>()

const { t } = useI18n()

const categoriesList = computed(() => {
  return BOOKING_REVIEW_CATEGORIES_ORDERED.flatMap((categoryOrdered) => {
    const value = props.categories[categoryOrdered]
    if (value === undefined) {
      return []
    }

    return [{
      label: t(`ratingCategories.${categoryOrdered}`),
      key: categoryOrdered,
      value,
    }]
  })
})
</script>
